import React from 'react';
import '@fontsource/inter';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CATEGORY_LABELS } from './types';
import { useGeneralContext } from '../../context';
import { userIsFree } from '../../util/subscription';

const NuggetCategoryFilter = (props: {
  categoryIndex: number;
  setCategoryIndex: React.Dispatch<React.SetStateAction<number>>;
  setShowPremiumModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { categoryIndex, setCategoryIndex, setShowPremiumModal } = props;
  const { subscriptionStatus } = useGeneralContext();

  const handleCategoryChange = (newIndex: number) => {
    if (userIsFree(subscriptionStatus)) {
      setShowPremiumModal(true);
      return;
    }
    setCategoryIndex(newIndex);
  };

  const handlePrevious = () => {
    const newIndex = categoryIndex === 0 ? CATEGORY_LABELS.length - 1 : categoryIndex - 1;
    handleCategoryChange(newIndex);
  };

  const handleNext = () => {
    const newIndex = categoryIndex === CATEGORY_LABELS.length - 1 ? 0 : categoryIndex + 1;
    handleCategoryChange(newIndex);
  };

  const currentCategory = CATEGORY_LABELS[categoryIndex];

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-gap-3">
      <button
        onClick={handlePrevious}
        className="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-p-0 tw-border tw-border-neutral-300 tw-rounded tw-bg-white"
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>

      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id={currentCategory.key}>{currentCategory.caption}</Tooltip>}
      >
        <div
          className="tw-font-bold tw-text-base lg:tw-text-lg tw-text-center"
          style={{
            width: 'clamp(150px, 30vw, 250px)',
            padding: '8px 16px',
            borderRadius: '8px',
            backgroundColor: `${currentCategory.color}20`,
            border: `2px solid ${currentCategory.color}`,
            transition: 'all 0.2s ease-in-out',
            opacity: 0.8
          }}
        >
          {currentCategory.label}
        </div>
      </OverlayTrigger>

      <button
        onClick={handleNext}
        className="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-p-0 tw-border tw-border-neutral-300 tw-rounded tw-bg-white"
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  );
};

export default NuggetCategoryFilter;
